

require('../../modules/es6.string.includes');
module.exports = require('../../modules/_core').String.includes;


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/fn/string/includes.js
// module id = ../node_modules/core-js/fn/string/includes.js
// module chunks = 0